// source: pushwoosh/applications_info/applications_info.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_api_annotations_pb = require('../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_duration_pb = require('google-protobuf/google/protobuf/duration_pb.js');
goog.object.extend(proto, google_protobuf_duration_pb);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest.displayName = 'proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse.displayName = 'proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.displayName = 'proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.displayName = 'proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    applicationsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest}
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest;
  return proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest}
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addApplications(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplicationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string applications = 1;
 * @return {!Array<string>}
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest.prototype.getApplicationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest.prototype.setApplicationsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest.prototype.addApplications = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoRequest.prototype.clearApplicationsList = function() {
  return this.setApplicationsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    applicationsPlatformsInfoList: jspb.Message.toObjectList(msg.getApplicationsPlatformsInfoList(),
    proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse}
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse;
  return proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse}
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.deserializeBinaryFromReader);
      msg.addApplicationsPlatformsInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplicationsPlatformsInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ApplicationPlatformsInfo applications_platforms_info = 1;
 * @return {!Array<!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo>}
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse.prototype.getApplicationsPlatformsInfoList = function() {
  return /** @type{!Array<!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo, 1));
};


/**
 * @param {!Array<!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo>} value
 * @return {!proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse} returns this
*/
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse.prototype.setApplicationsPlatformsInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo}
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse.prototype.addApplicationsPlatformsInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse} returns this
 */
proto.pushwoosh.rpc_v2.applications_info.GetPlatformsInfoResponse.prototype.clearApplicationsPlatformsInfoList = function() {
  return this.setApplicationsPlatformsInfoList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    application: jspb.Message.getFieldWithDefault(msg, 1, ""),
    platformsMap: (f = msg.getPlatformsMap()) ? f.toObject(includeInstance, proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo;
  return proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplication(value);
      break;
    case 2:
      var value = msg.getPlatformsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readUint32, jspb.BinaryReader.prototype.readMessage, proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.deserializeBinaryFromReader, 0, new proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplication();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlatformsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeUint32, jspb.BinaryWriter.prototype.writeMessage, proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.serializeBinaryToWriter);
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    isConfigured: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    isActive: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    deactivationDate: (f = msg.getDeactivationDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    deactivationReason: jspb.Message.getFieldWithDefault(msg, 4, ""),
    certificateTimeLeft: (f = msg.getCertificateTimeLeft()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    propertiesMap: (f = msg.getPropertiesMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo;
  return proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsConfigured(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeactivationDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeactivationReason(value);
      break;
    case 5:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setCertificateTimeLeft(value);
      break;
    case 6:
      var value = msg.getPropertiesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsConfigured();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDeactivationDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDeactivationReason();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCertificateTimeLeft();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getPropertiesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional bool is_configured = 1;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.getIsConfigured = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo} returns this
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.setIsConfigured = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool is_active = 2;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo} returns this
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp deactivation_date = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.getDeactivationDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo} returns this
*/
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.setDeactivationDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo} returns this
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.clearDeactivationDate = function() {
  return this.setDeactivationDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.hasDeactivationDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string deactivation_reason = 4;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.getDeactivationReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo} returns this
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.setDeactivationReason = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Duration certificate_time_left = 5;
 * @return {?proto.google.protobuf.Duration}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.getCertificateTimeLeft = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 5));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo} returns this
*/
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.setCertificateTimeLeft = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo} returns this
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.clearCertificateTimeLeft = function() {
  return this.setCertificateTimeLeft(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.hasCertificateTimeLeft = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * map<string, string> properties = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.getPropertiesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo} returns this
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.prototype.clearPropertiesMap = function() {
  this.getPropertiesMap().clear();
  return this;};


/**
 * optional string application = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.prototype.getApplication = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo} returns this
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.prototype.setApplication = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * map<uint32, PlatformInfo> platforms = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo>}
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.prototype.getPlatformsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo} returns this
 */
proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.prototype.clearPlatformsMap = function() {
  this.getPlatformsMap().clear();
  return this;};


goog.object.extend(exports, proto.pushwoosh.rpc_v2.applications_info);
